import { Blog } from './Blog';

export type { TypeBlogProps } from './types';
export default Blog;
